<template>
  <div
    class="subheader py-3 py-lg-8 subheader-transparent"
    v-bind:class="subheaderClasses"
    id="kt_subheader"
  >
    <div
      class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap
      "
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="subheader-copy d-flex align-items-baseline mr-5">
        <!--begin::Page Title-->
        <h2 class="subheader-title text-primary font-weight-bold my-2 mr-3">
          {{ title }}
        </h2>
        <!--end::Page Title-->
        <!--begin::Breadcrumb-->
        <ul
          class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold my-2 p-0"
        >
          <template v-for="(breadcrumb, i) in breadcrumbs">
            <li :key="`${i}-${breadcrumb.id}`" class="">
              <router-link
                :key="`${i}-${breadcrumb.id}`"
                v-if="breadcrumb.route"
                :to="breadcrumb.route"
                class="text-custom font-weight-light"
              >
                {{ breadcrumb.title }}
              </router-link>
              <span
                class="text-custom font-weight-light"
                :key="`${i}-${breadcrumb.id}`"
                v-if="!breadcrumb.route && breadcrumb.purpose !== 'message'"
              >
                {{ breadcrumb.title }}
              </span>
              <span
                class="text-custom font-weight-light"
                :key="`${i}-${breadcrumb.id}`"
                v-if="breadcrumb.purpose === 'message'"
              >
                {{ breadcrumb.role }}
              </span>
            </li><b-icon :key="`${i}-dot`" icon="dot" v-if="i != breadcrumbs.length - 1"></b-icon>
          </template>
        </ul>
        <!-- begin::Announcement -->
        <div class="announcement-position">
          <marquee class="text-danger marque-loop" :loop="loopTotal" v-if="startContent">
            <span v-html="announcementContent"></span>
          </marquee>
        </div>
        <!-- <div class="announcement-position">
          <marquee class="text-danger">
            <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum in dolorem, minus consequatur cum odio ab maiores modi commodi natus reprehenderit deserunt aspernatur omnis voluptas pariatur accusamus quidem asperiores perferendis?</span>
          </marquee>
        </div> -->
        <!--end::Announcement-->
        <!--end::Breadcrumb-->
      </div>

      <!--begin::Toolbar-->
      <div class="subheader-toolbar d-flex align-items-center">
        <button
          type="button"
          class="subheader-action"
          :aria-label="isDarkMode ? 'Aktifkan mode terang' : 'Aktifkan mode gelap'"
          :title="isDarkMode ? 'Mode terang' : 'Mode gelap'"
          @click="toggleDarkMode"
        >
          <i :class="isDarkMode ? 'fas fa-sun' : 'fas fa-moon'" aria-hidden="true"></i>
        </button>
        <span class="subheader-separator" aria-hidden="true"></span>
        <div class="subheader-profile">
          <span class="subheader-profile__copy d-none d-sm-block">
            <strong>{{ (userData && userData.name) || "Administrator" }}</strong>
            <small>{{ (userData && userData.role_name) || "Medhop SaaS" }}</small>
          </span>
          <span class="subheader-profile__avatar" aria-hidden="true">{{ userInitial }}</span>
          <span class="subheader-profile__status" aria-label="Online"></span>
        </div>
      </div>
      <!--end::Toolbar-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import module from "@/core/modules/CrudModule.js";
import { getUser, setUser } from "@/core/services/jwt.service.js";

export default {
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    title: String,
  },
  data() {
    return {
      mainProps: { blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' },
      announcements: [],
      loopTotal: 3,
      announcementContent: '',
      startContent: false,
      userData: {},
      isDarkMode: false
    };
  },
  methods: {
    onStart(evt){
      //("onstart", evt)
    },
    onFinish(evt){
      //("onFinish", evt)
    },
    async get() {
      const user = getUser();
      if (user && user.id) {
        try {
          const res = await module.get('users/' + user.id);
          if (res) this.userData = res;
        } catch (e) {}
      }
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      const theme = this.isDarkMode ? "dark" : "light";
      localStorage.setItem("theme", theme);
      document.documentElement.setAttribute("data-theme", theme);
      this.$root.$emit("theme-changed", theme);
    },
  },
  mounted() {
    this.isDarkMode = (localStorage.getItem("theme") || "light") === "dark";
    this.get()

    this.$root.$on("refreshCurrentUser", () => {
      this.get()
    });
    this.$root.$on("theme-changed", (theme) => {
      this.isDarkMode = theme === "dark";
    });

    // this.$nextTick(() => {
    //   let newEl = this.$el.getElementsByClassName("marque-loop")
    //   //("new element", newEl)
    // });
    // //("element", el)
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }

        if (this.layoutConfig("subheader.clear")) {
          classes.push("mb-0");
        }
      }
      return classes.join(" ");
    },
    userInitial() {
      const name = this.userData && this.userData.name
        ? this.userData.name.trim()
        : "M";
      return name.charAt(0).toUpperCase();
    },
  },
};
</script>

<style scoped>
.announcement-position{
  /* style="position: absolute; bottom: 0px; width: 90%" */
  position: fixed;
  top: 0px;
  width: 100%;
}

.text-custom{
  color: #ff6000;
}

/* mobile */
@media (max-width: 767.98px) { 
.announcement-position{
  /* style="position: absolute; bottom: 0px; width: 90%" */
  position: absolute;
  top: 10%;
  width: 90%;
}
}
</style>
